/*
  Gaia Iluka — Culinary Partners: overlay application submission
  File: assets/gi-cu-overlay.js

  NEW (Culinary Partners pass, 4 Sep 2026). Progressive enhancement
  only. The form inside sections/gi-cu-overlay.liquid is the exact field
  markup that lived in sections/gi-cu-apply.liquid — same
  {% form 'contact' %} tag, same field names, same required email, same
  hidden contact[Enquiry] value — relocated into the overlay rather than
  duplicated. It is Shopify's own contact form with a real action and a
  real method. If this script never loads, never runs, or throws before
  it attaches a listener, the form still submits exactly as it always
  did: a normal POST to /contact, a normal redirect back, and the
  section's own Liquid-rendered .cu-form-success / .cu-form-error blocks
  render on reload. THIS SCRIPT ONLY ADDS AN IN-PLACE CONFIRMATION FOR
  THE COMMON CASE — it does not touch the form's fields, its action, its
  method, its required attribute or its contact[Enquiry] value.

  WHY IT IS A SEPARATE FILE FROM assets/gi-cc-overlay.js, WHICH IT
  CLOSELY RESEMBLES. The two could share one generic script, and
  eventually should. They do not yet because generalising means editing
  the Creator Circle's live submission path, and this pass was scoped to
  leave the Creator Circle application mechanics untouched. Consolidating
  the two is a deliberate follow-up, not an oversight — when it happens,
  the only differences to reconcile are the four selectors below.

  WHY A FETCH SUBMISSION IS SAFE HERE, AND WHY IT DOESN'T PARSE THE
  RESPONSE. Email is the form's only required field, and the browser's
  own required + type="email" validation blocks the submit event from
  firing at all on an empty or malformed address — Shopify's contact
  form has no further business validation beyond that. So the realistic
  failure surface is network failure, not a content validation Shopify
  would reject; this script treats any non-2xx response or a thrown
  fetch error as failure and leaves the form intact with a plain retry
  message, rather than parsing the returned HTML for error markers that
  essentially cannot appear once the browser has accepted the address.

  WHAT HAPPENS ON SUCCESS. The form root (.cu-form) AND THE OVERLAY'S
  HEADER (.cu-overlay-head) are both hidden, and the confirmation panel —
  markup in gi-cu-overlay.liquid, hidden by default — is shown in their
  place, inside the still-open dialog. The header goes too because it
  says "Tell us about your restaurant or business", which contradicts
  "Thank you." sitting directly beneath it; leaving it up is the
  difference between a confirmation and a form that has gone quiet.
  Nothing closes the dialog automatically; the visitor closes it
  themselves, with the dialog engine's own close control or with the
  confirmation's button.

  RESET ON REOPEN. If the dialog is closed and reopened, the
  confirmation panel is hidden and the form is shown again, so nobody
  sees a stale "thank you" for a form they have not filled in this time.
*/

(function () {
  'use strict';

  function init() {
    var overlay = document.getElementById('gi-cu-overlay');
    if (!overlay) return;

    var form = overlay.querySelector('.cu-form-el');
    var formRoot = overlay.querySelector('.cu-form');
    var headEl = overlay.querySelector('.cu-overlay-head');
    var confirmEl = overlay.querySelector('.cu-overlay-confirm');
    var errorEl = overlay.querySelector('.cu-overlay-error');

    // Reset to the form view every time the dialog is shown, so a prior
    // submission never leaves a stale confirmation behind.
    overlay.addEventListener('dialog:open', reset);

    function reset() {
      if (formRoot) formRoot.hidden = false;
      if (headEl) headEl.hidden = false;
      if (confirmEl) confirmEl.hidden = true;
      if (errorEl) errorEl.hidden = true;
    }

    if (!form) return;

    var submitBtn = form.querySelector('button[type="submit"]');
    var sendingLabel = submitBtn ? submitBtn.getAttribute('data-sending-label') : null;
    var originalLabel = submitBtn ? submitBtn.textContent : null;

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      if (errorEl) errorEl.hidden = true;

      if (submitBtn) {
        submitBtn.disabled = true;
        if (sendingLabel) submitBtn.textContent = sendingLabel;
      }

      fetch(form.getAttribute('action'), {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'text/html' },
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Culinary Partner application request failed: ' + response.status);

          if (formRoot) formRoot.hidden = true;
          if (headEl) headEl.hidden = true;
          if (confirmEl) {
            confirmEl.hidden = false;
            confirmEl.setAttribute('tabindex', '-1');
            confirmEl.focus();
          }
        })
        .catch(function () {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = originalLabel;
          }
          if (errorEl) errorEl.hidden = false;
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
